import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import lozad from 'lozad';

import LoadingIcon from '../../components/LoadingIcon';
import EmailSignup from '../../components/Sections/EmailSignup';
import BandcampPlayerLarge from '../../components/Media/BandcampPlayerLarge';
import SpotifyPlayerLarge from '../../components/Media/SpotifyPlayerLarge';
import SpotifyPlayerSmall from '../../components/Media/SpotifyPlayerSmall';
import SpotifyFollowButton from '../../components/Media/SpotifyFollowButton';
import YoutubeVideo from '../../components/Media/YoutubeVideo';
import SongKickTourBox from '../../components/Media/SongKickTourBox';
import About from '../../components/Sections/About';
import SocialLinks from '../../components/Sections/SocialLinks';
import FeaturedShows from '../../components/Sections/FeaturedShows';
import PromotionalHero from '../../components/PromotionalHero';

function mapStateToProps(state) {
   return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

class Home extends Component {

  handleClickBuyAlbum() {
    ReactGA.event({
        category: 'Click',
        action: 'Buy Album',
    });
  }

  handleClickShopNow() {
    ReactGA.event({
        category: 'Click',
        action: 'Shop Now',
    });
  }

  render() {


    let album_bound_and_revolving = 'https://open.spotify.com/embed/album/7KFf0FEtLaqyLDWBIbuPip';
    let album_luggage_underneath = 'https://open.spotify.com/embed/album/1KjUyIXBTwWHJ5gFeEMRLS';
    let album_spare_parts = 'https://open.spotify.com/embed/album/432fXgHmXnZTLLNr406xUR';
    // let video_link = "https://www.youtube.com/embed/V8VjhGliTFs";
    // let video_link = 'https://www.youtube.com/embed/G8IfbiqnS1w'; // Gilded Guilt High Dive
    // let video_link = 'https://www.youtube.com/embed/ivr20774r9I'; // hot wax release video
    let video_link = 'https://www.youtube.com/embed/Wblrwviq1N4' // nine o clock shadow
    // let video_link = 'https://www.youtube.com/embed/lHDzNfpuphY';

    return (
      <div className="Home">

        <div className="Home__section">
          <YoutubeVideo src={video_link} />
        </div>
        
        <div className="layout-main">

          <div className="Home__section Home__about">
            <About />
          </div>

          <div className="Home__section card Home__tour__card">
            <SongKickTourBox />
          </div>

          <div className="Home__section">
            <EmailSignup />
          </div>

          <div className="Home__section Home__social">
            <SocialLinks />
          </div>

          <div className="Home__section Home__contact">
            <h2>Contact us</h2>
            <p>Interested in booking Moose Almighty?</p> 
            <p><Link to="/presskit">View press kit</Link></p>
            <p><Link to="/contact">Contact Moose Almighty</Link></p>
          </div>

        </div>

        <div className="layout-sidebar">
          
          <div className="Home__section Home__music">
            <SpotifyPlayerLarge
              url={album_spare_parts}
              height="305px"
            />

            <div className="Home__music_spotify-follow">
              <SpotifyFollowButton /> 
            </div>
          </div>
          

          <div className="Home__section Home__merch">
            <Link to="/store">
              <img 
                src="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_merchandise_photo.jpg" 
                alt="Moose Almighty Merchandise. Shop now at out online store."
                className="lozad"
              />
            </Link>
            <h3>Moose Almighty Merchandise</h3>
            <Link to="/store">
              <button onClick={this.handleClickShopNow} className="btn btn--primary btn--100">Shop Now</button>
            </Link>
          </div>

          <div className="Home__bottom-logo">
            <img 
              src="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_full_logo_color.png" 
              alt="Moose Almighty logo"
              className="lozad"
            />
          </div>
          
        </div>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);

// <div className="Home__section Home__tour">

//   <FeaturedShows />
  
// </div>



// WEBPACK FOOTER //
// ./src/views/Home/Home.js